let env = {};

env.baseURL = 'https://api.modern.humanflow.com.br/api/v1/';
env.normalURL = 'https://api.modern.humanflow.com.br/';
env.frontUrl = 'https://app.modern.humanflow.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js